import React from 'react';
import '../css/App.css';
import '../css/DesktopPage.css';
import { getUserData } from '../actions/userActions';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import YouTube from "react-youtube"; // requires a loader
import TweetEmbed from 'react-tweet-embed';
import { Props, State } from "./IDesktopPage";
import Numeral from 'numeral';
import GlobalHelper from "../helpers/globalHelper";


export class DesktopPage extends React.Component<Props, State> {
    private vidRef: any;
    private autoplay_video: boolean;
    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            config: {
                mainColor: ' #fcd000',
                secondColor: '#d267e0',
                appBackground: '#20294e',
                buttons: [],
                video_first: true,
                disable_page: false
            },
            isPlaying: false,
            selectedPopupData: null,
            showPopa: false,
            showPlaybutton: true,
            currentSlide: 1,
            postsView: 'grid'
        };

        this.autoplay_video = false
    }

    componentDidMount() {
        const username = window.location.pathname.replace("/i/", "");
        getUserData(username, (response) => {
            if (response) {
                this.setState({ data: response }, () => {
                    document.title = response.name + " - Humanz";
                    this.loadUserSettings();
                });

                //remove, just debugging
                console.log(this.state.data);

                if (this.state.data?.intro_video && this.autoplay_video) {
                    this.playVideo().then(res => {
                        this.setState({ showPlaybutton: false })
                    })
                }

                if(!this.state.data?.linked_posts || !this.state.data?.linked_posts.length){
                    let linkedPosts = [];
                    for(let i=0; i<6; i++){
                        linkedPosts.push({post_thumbnail:''});
                    }
                    // @ts-ignore
                    this.state.data.linked_posts = linkedPosts;
                    // @ts-ignore
                    this.setState({})
                }
            }else{
                window.location.href='https://www.humanz.com/404';
            }
        })
    }

    loadUserSettings = () => {
        let tempstate = { ...this.state };
        if (tempstate.data && tempstate.config && tempstate.data.external_page_settings) {
            let s = tempstate.data.external_page_settings;
            tempstate.config.mainColor = s.primary_color;
            tempstate.config.secondColor = s.secondary_color;
            tempstate.config.buttons = s.buttons;
            tempstate.config.video_first = s.video_first;
            tempstate.config.disable_page = s.disable_page;
            this.setState(tempstate, () => {
                // do after user settings are applied
                // @ts-ignore
                if (this.state.config) {
                    if (this.state.config?.buttons && this.state.config?.buttons?.length) {
                        // @ts-ignore
                        this.state.config.buttons.sort((a, b) => (a.position > b.position))
                    }
                }
            });
        }
    };

    stopVideo = () => {
        if (!this.vidRef) return;
        try {
            this.vidRef.pause().then(() => {
                this.setState({ isPlaying: !this.vidRef.paused, showPlaybutton: !this.state.isPlaying });
            }).catch((e: any) => {
                console.log(e, "Browser doesnt support playing on load");
            });
        } catch (e) {
            console.log("Browser doesnt support playing on load");
        }
    }

    renderPost = (post: string, selectedSocial: string) => {
        if (selectedSocial === 'ig_post')
            return (<div className="blurable-frame">
                <iframe
                    src={"https://www.instagram.com/p/" + post + "/embed/captioned"}
                    width="100%" height="400" frameBorder="0" scrolling="no"></iframe>
            </div>);

        if (selectedSocial === 'ig_story')
            return (
                <div className="story-image-container">
                    {post ?
                        <img className="blurable" src={post} />
                        :
                        <div className="empty-image" />
                    }
                </div>);
        if (selectedSocial === 'tw_tweet')
            return (<div className="blurable-frame">
                <TweetEmbed id={post} />
            </div>);

        if (selectedSocial === 'yt_video')
            return (
                <div className="blurable-frame" style={{
                    display: 'inline-block',
                    width: '100%',
                    overflow: 'hidden',
                    marginTop: '10px'
                }}>
                    <YouTube
                        videoId={post}
                        opts={{ width: '100%' }}
                    />
                </div>
            );

        if (selectedSocial === 'tk_video')
            return (<div className="blurable-frame">
                <iframe style={{
                    display: 'block',
                    width: '100%',
                    height: 'calc(100vh - 49px)',
                    overflow: 'hidden'
                }}
                    src={"https://www.tiktok.com/embed/" + post}
                    frameBorder={"0"}
                    allow={"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"} />
            </div>);
    };

    renderPopa = (selectedPopupData: any) => {
        // if(this.state.selectedPopupData){
        return (<div className={'popa' + (this.state.showPopa ? ' swing-in-bottom-fwd ' : ' hidden')}>
            {this.state.selectedPopupData && <>
                <i className="post-loader rotate-center fas fa-circle-notch" />
                <div className="close" onClick={() => {
                    this.setState({ showPopa: false });
                    setTimeout(() => {
                        this.setState({ selectedPopupData: null });
                    }, 1000);
                }}><i className="far fa-times-circle" /></div>
                <div className="post">
                    {this.renderPost(selectedPopupData.post, selectedPopupData.selectedSocial)}
                </div>
            </>}
        </div>);
    };

    playVideo = async () => {
        if (this.vidRef) {
            this.setState({ isPlaying: true });
            try {
                this.vidRef.play().then(() => {
                    this.setState({ isPlaying: !this.vidRef.paused, showPlaybutton: false });
                }).catch((e: any) => {
                    console.log(e, "Browser doesnt support playing on load");
                });
            } catch (e) {
                console.log("Browser doesnt support playing on load");
            }
        }
    };

    getVideo = (elem: any) => {
        this.vidRef = elem;
    };

    renderVideo = () => {
        if (!this.state.data || !this.state.config) return;

        if (this.state.data?.intro_video && this.state.data.intro_video !== '') {
            return <div className={"intro-video"}>
                <video playsInline autoPlay={false} ref={this.getVideo} controls={true}
                    src={decodeURIComponent(this.state.data.intro_video)} />
            </div>
        }
        if (this.state.data?.intro_thumbnail) {
            return <div className={'intro-video'}
                style={{ backgroundImage: ('url(' + this.state.data.intro_thumbnail + ')') }} />
        }
        if (this.state.data?.image) {
            return <div className={'intro-video'} style={{ backgroundImage: ('url(' + this.state.data.image + ')') }} />
        }
        return <div className={'intro-video'} style={{ backgroundColor: this.state.config.mainColor }} />
    };

    renderSocialCounters = () => {
        if (!this.state.data || !this.state.data.social_data) return null;
        return <div className={'social-counter slide-left'}>
            {Object.keys(this.state.data?.social_data).map((i: any) => {
                return this.state.data?.social_data[i] ? (
                    <div key={'social_c_' + i} className={'single-social-counter'} style={{ color: this.state.config?.secondColor, borderRightColor: this.state.config?.secondColor + ' !important' }}>
                        <a target="_blank" style={{ color: 'white', textDecoration: 'none',fontSize:'2em' }} href={GlobalHelper.openSocialPage(i, this.state.data.social_data[i].username)}>
                            {/* <span className="followers">{this.formatNumber(this.state.data?.social_data[i]?.followers)}</span> */}
                            <span className="social-icon"><i className={"fab " + (GlobalHelper.getSocialIcon(i))} /></span>
                        </a>
                    </div>) : '';
            })}
        </div>
    };

    renderCustomButtons = () => {
        if (!this.state.data || !this.state.data.external_page_settings || !this.state.config || !this.state.config.buttons.length) return null;
        return <div className="custom_buttons">
            {<div className={"second-buble scale-in-right"} style={{ backgroundColor: this.state.config?.secondColor }} />}
            {this.state.config.buttons.map((b, i) => {
                // @ts-ignore
                return (<>
                    <a style={{ color: this.state.config ? this.state.config.secondColor : "black" }} target={"_blank"}
                        id={b.id} href={b.link}><span className="circle" style={{backgroundColor:this.state.config?.secondColor}} />{b.label}</a>
                </>)
            })}
        </div>
    };

    render() {
        const { data } = this.state;
        if (!this.state.data) return null;
        return (
            <div className="DesktopPage" style={{ background: this.state.config?.mainColor }}>
                <section>
                    <div className="second-background-wrapper">
                        <div className="small-logo humanz-logo fadein"><a href="https://www.humanz.com/creators/"><img src={"images/logo.svg"} width={120}
                                                                                                             alt="" /></a></div>
                        <div className={"second-background-circle " + ('full')}
                            style={{ background: (this.state.config?.secondColor) }} />
                    </div>
                    <div className="video-wrapper">
                        {this.renderVideo()}
                    </div>

                    <div className="user-details">
                        <div className="col-small slide-bottom">
                            <div className={'username hue'}>
                                {data?.username || data?.name}
                            </div>
                        </div>
                    </div>
                    <div className="humanz-logo-big">
                        <div className="humanz-logo fadein"><img src={"images/logo.svg"} width={"70vh"} alt="" /></div>
                    </div>

                    <div className="content-container effect-container" >
                        <div className="about-wrapper effect-inner">
                            {<div className={'about-details'} style={{ background: this.state.config?.mainColor }}>
                                <div className="step2-header-container">
                                    <img className="user-image scale-in-center" alt="user" src={data?.image} />
                                </div>
                                <div className={"social-counters smaller"}>
                                    {this.renderSocialCounters()}
                                </div>
                                <div className={"about " + ('slide-left-m')} style={{ animationDelay: '0s' }}>
                                    <strong>{data?.name}</strong> <br />
                                    <div className="about-text" >
                                        <span className="bio-text" dangerouslySetInnerHTML={GlobalHelper.addLinks(data?.about)}/>
                                        <div className="about-bar slide-in-bottom" />
                                    </div>
                                    {this.renderCustomButtons()}
                                    {GlobalHelper.renderHumanzAcademyBadge(data?data.academy_badge:false)}

                                </div>
                            </div>}
                            {this.renderPosts()}
                        </div>
                    </div>

                </section>
                {/*popup*/}
                <div className="watermark">
                    <img src={"images/watermark.png"} alt="" />
                </div>
                {this.renderPopa(this.state.selectedPopupData)}
            </div>
        );
    }

    renderPosts = () => {
        let carusel = <section className="full-section posts tilt-in-fwd-bl">
            {/*posts carousel*/}
            {this.state.data?.linked_posts && <Carousel selectedItem={this.state.currentSlide} onClickItem={(i) => {
                let post = this.state.data?.linked_posts[i];
                this.setState({
                    showPopa: true,
                    selectedPopupData: { post: post.media_id, selectedSocial: post.post_type }
                })
            }} className={""} showIndicators={false} centerMode={true} swipeable={true} infiniteLoop={true}
                showStatus={false} emulateTouch={true} showThumbs={false}>
                {this.state.data?.linked_posts.map((post, i) => {
                    if (post.thumbnail)
                        return (<div className={"single-post"} key={'post_' + i}>
                            <img src={post.thumbnail} />
                        </div>);
                    return this.renderEmptyImage(post, i);
                })}
            </Carousel>}
        </section>;

        let posts = <section className="full-section posts tilt-in-fwd-bl">
            {this.state.data?.linked_posts && <div className={"posts-grid"}>
                {this.state.data?.linked_posts.map((post, i) => {
                    console.log(post,i)
                    if (post.thumbnail)
                        return (<div className={"single-post tilt-in-fwd-bl"}
                            style={{ animationDelay: (Math.random() * (0.5 - 0.1 + 1) + 0.5) + 's' }}
                            key={'post_' + i} onClick={() => {
                                let post = this.state.data?.linked_posts[i];
                                this.setState({
                                    showPopa: true,
                                    selectedPopupData: { post: post.media_id, selectedSocial: post.post_type }
                                })
                            }}>
                            <img src={post.thumbnail} />
                        </div>);
                    return this.renderEmptyImage(post, i);
                })}
            </div>}
        </section>;

        // We can select between posts grid view or carousel view;
        // return carusel;
        return this.state.postsView === 'carousel' ? carusel : posts;
    };

    renderEmptyImage = (post: any, i: number) => {
        if (post.caption) {
            return <div className={"single-post tilt-in-fwd-bl"}
                style={{ animationDelay: `${(Math.random() * (0.3 - 0.1 + 1) + 0.3)}s` }}>
                <div key={'post_' + i} className={'color-change-4x caption'}
                    style={{ animationDelay: `${(Math.random() * (4 - 0.1 + 1) + 0.1)}s` }}>
                    <div className="caption">{post.caption}</div>
                    <div className="social-icon"><i className={"fab " + (GlobalHelper.getSocialIcon(post.post_type))} /></div>
                </div>
            </div>
        }
        return <div key={'post_' + i} style={{ animationDelay: (Math.random() * (4 - 0.1 + 1) + 0.1) + 's' }} className={'color-change-4x empty-image single-post'}>
            <i className="fas fa-images" /> <span>Post coming soon!</span></div>;
    }
}

export default DesktopPage;